import React from "react";
import { Stack, TextField, IconButton, Typography, Tooltip } from "@mui/material";
import { ImagesSquare, PaperPlaneTilt } from "@phosphor-icons/react";
import { useSelector } from "react-redux";
import { isCustomerCare, isDirector, isSupervisor } from "selectors";

const MessageInput = ({
  message,
  onChange,
  onSend,
  onUploadPress,
  participantData,
  notificationsEnabled,
}) => {
  const isCustomerCareUser = useSelector(isCustomerCare);
  const isDirectorUser = useSelector(isDirector);
  const isSupervisorUser = useSelector(isSupervisor);
  const lastMessageDate = participantData?.metadata?.last_outbound_message;
  // Check if last outbound message was within the last 72 hours
  const isWithinLast72Hours = lastMessageDate
    ? (new Date() - new Date(lastMessageDate)) / (1000 * 60 * 60) < 72
    : false;

  return (
    <Stack p="24px" gap="8px" position="relative">
      <Stack direction="row" gap="8px" alignItems="center">
        <Tooltip title="Add attachment" placement="top">
          <IconButton onClick={onUploadPress} fontSize="small">
            <ImagesSquare weight="duotone" />
          </IconButton>
        </Tooltip>

        <TextField
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
          placeholder="Write a message..."
          fullWidth
          multiline
          minRows={1}
          value={message}
          sx={{
            '& .MuiInputBase-root': {
              alignItems: 'flex-end',
            },
            '& .MuiInputBase-input': {
              resize: 'none',
              overflow: 'hidden',
            }
          }}
        />

        <Tooltip title="Send message" placement="top">
          <IconButton onClick={onSend} fontSize="small" disabled={!message}>
            <PaperPlaneTilt weight="duotone" />
          </IconButton>
        </Tooltip>
      </Stack>

      {(isCustomerCareUser || isDirectorUser || isSupervisorUser) &&
        !isWithinLast72Hours &&
        !notificationsEnabled && (
          <Typography variant="caption" color="text.secondary" textAlign="center">
            Sending a message will turn on notifications for the next 72 hours.
          </Typography>
        )}
    </Stack>
  );
};

export default MessageInput;
